import React from "react";
import Card from "@material-ui/core/Card";
import CardActionArea from "@material-ui/core/CardActionArea";
import Typography from "@material-ui/core/Typography";
import Divider from "@material-ui/core/Divider";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import makeStyles from "@material-ui/core/styles/makeStyles";
import { formatPrice } from "../Utils/Utils";
import VideoLibraryIcon from "@material-ui/icons/VideoLibrary";
import AccessTimeIcon from "@material-ui/icons/AccessTime";
import AssignmentIcon from "@material-ui/icons/Assignment";
import PlayCircleOutlineIcon from "@material-ui/icons/PlayCircleOutline";
import PlaylistPlayIcon from "@material-ui/icons/PlaylistPlay";
import { Link } from "react-router-dom";
import { Box } from "@material-ui/core";
import { baseUrl } from "../Api/Api";

const useStyles = makeStyles((theme) => ({
  card: {},
  chip: {
    margin: theme.spacing(0.5),
  },
  section1: {
    minHeight: 200,
    margin: theme.spacing(2, 2, 1, 2),
  },
  section2: {
    margin: theme.spacing(1),
    textAlign: "center",
  },
  section3: {
    margin: theme.spacing(2),
    textAlign: "center",
  },
  priceChip: {
    fontWeight: "bold",
    backgroundColor: theme.palette.background.white,
    color: theme.palette.primary.main,
    fontSize: "125%",
    borderStyle: "solid",
    borderColor: theme.palette.primary.main,
    borderWidth: "2px",
  },
  titleDecoration: {
    display: "inline",
    borderBottomStyle: "solid",
    borderBottomColor: theme.palette.primary.main,
    borderBottomWidth: "2px",
  },
}));

const getCallToActionBtn = (courseType) => {
  if (courseType === "video") {
    return (
      <Button
        fullWidth={true}
        color={"primary"}
        variant={"contained"}
        startIcon={<PlayCircleOutlineIcon />}
      >
        Přehrát kurz
      </Button>
    );
  }
  if (courseType === "test") {
    return (
      <Button
        fullWidth={true}
        color={"primary"}
        variant={"contained"}
        startIcon={<PlaylistPlayIcon />}
      >
        Spustit test
      </Button>
    );
  }
  if (courseType === "collectionOfExamples") {
    return (
      <Button color={"primary"} variant={"contained"}>
        Ukázat sbírku
      </Button>
    );
  }

  return <></>;
};

const CourseItemVideo = (props) => {
  const { course } = props;

  const classes = useStyles();

  return (
    <Grid item xs={12} sm={6} md={3}>
      <Card className={classes.card}>
        <Link to={"/kurz/" + course.slug} style={{ textDecoration: "none" }}>
          <CardActionArea>
            <div className={classes.section1}>
              <Grid container direction={"column"}>
                <Grid item container alignItems={"baseline"}>
                  <Grid item xs>
                    <Typography
                      variant={"subtitle1"}
                      color={"textSecondary"}
                      gutterBottom
                    >
                      {course.category.title}
                    </Typography>
                  </Grid>
                  <Grid item>
                    <Typography color={"primary"} gutterBottom>
                      <strong>{formatPrice(course.price)}</strong>
                    </Typography>
                  </Grid>
                </Grid>
                <Grid item xs>
                  <Typography
                    gutterBottom
                    variant="h5"
                    style={{ fontWeight: "bold" }}
                  >
                    {course.title}
                  </Typography>
                </Grid>
              </Grid>
              <Typography color="textSecondary" variant="body2">
                {course.description}
              </Typography>
            </div>
          </CardActionArea>
        </Link>
        <Divider />
        <div className={classes.section3}>
          <Link to={"/kurz/" + course.slug}>
            {getCallToActionBtn(course.courseType.code)}
          </Link>
        </div>
      </Card>
    </Grid>
  );
};

const CourseItemTest = (props) => {
  return <CourseItemVideo {...props} />;
};

const CourseItemCollectionOfExamples = (props) => {
  const { course } = props;

  return (
    <Grid item xs={12} sm={6} md={3}>
      <Box>
        <Link
          to={"/sbirky-prikladu/" + course.slug}
          style={{ textDecoration: "none" }}
        >
          <Box
            component={"img"}
            src={
              baseUrl +
                "/uploads/files/" +
                course?.collectionOfExamples?.thumbnailImageFiles[0]
                  ?.fileName || ""
            }
            alt={course.title}
            style={{ width: "100%" }}
          />
        </Link>
      </Box>
      <Box style={{ marginTop: 16, textAlign: "center" }}>
        <Link to={"/sbirky-prikladu/" + course.slug}>
          {getCallToActionBtn(course.courseType.code)}
        </Link>
      </Box>
    </Grid>
  );
};

const Courses = (props) => {
  const classes = useStyles();

  const { courses } = props;

  return (
    <Grid
      container
      direction="row"
      spacing={2}
      justify="center"
      alignItems="stretch"
    >
      {courses.map((course) => {
        return (
          <React.Fragment key={courses.indexOf(course)}>
            {course.courseType.code === "video" && (
              <CourseItemVideo course={course} />
            )}
            {course.courseType.code === "test" && (
              <CourseItemTest course={course} />
            )}
            {course.courseType.code === "collectionOfExamples" && (
              <CourseItemCollectionOfExamples course={course} />
            )}
          </React.Fragment>
        );
      })}
    </Grid>
  );
};

export default Courses;
